module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-doc@2x-2a8920c581d5802f358f6b3aedbf4fa9.png";